/* Copyright 2014 The MathWorks, Inc. */

/**
 * This is a list of the component types that do not get added to a parent widget. They are added to their specific root
 * nodes in the peer model tree.
 */

define([
    "../constants/TypeConstants"
], function (TypeConstants) {
    return [
        TypeConstants.TOOLSTRIP,
        TypeConstants.POPUP_LIST,
        TypeConstants.GALLERY_POPUP,
        TypeConstants.GALLERY_FAVORITE_CATEGORY
    ];
});

